export const PROPERTY_QUESTIONS = 'questions';
export const PROPERTY_QUESTIONS_RELATED = 'relatedQuestions';
export const PROPERTY_QUESTION_INDEX = 'questionIndex';
export const PROPERTY_ANSWERS = 'answers';
export const PROPERTY_SHUFFLE = 'shuffle';
export const PROPERTY_MEDIA = 'media';
export const PROPERTY_ALLOW_DECIMALS = 'allowedDecimals';
export const PROPERTY_MIN = 'min';
export const PROPERTY_MAX = 'max';
export const PROPERTY_MIN_LENGTH = 'minLength';
export const PROPERTY_MAX_LENGTH = 'maxLength';
export const PROPERTY_MAX_LIMIT = 'maxLimit';
export const PROPERTY_SLIDER = 'slider';
export const PROPERTY_RATING_SIZE = 'ratingSize';
export const PROPERTY_RANKING_OPTIONS = 'rankingOptions';
export const PROPERTY_SCOREPOINTS = 'scorepoints';
export const PROPERTY_MATRIX = 'matrix';
export const PROPERTY_MATRIX_COLUMNS = 'columns';
export const PROPERTY_MATRIX_ANSWERS = 'matrixAnswers';
export const PROPERTY_MATRIX_EXTRA_LABELS = 'matrixExtraLabels';
export const PROPERTY_MATRIX_STYLE = 'matrixStyle';
export const PROPERTY_CARRY_FORWARD = 'carryForward';
export const PROPERTY_DISPLAY_SAME_PAGE = 'displaySamePage';
export const PROPERTY_LOOP_MERGE = 'loopAndMerge';
export const PROPERTY_CONCEPTS = 'concepts';
export const PROPERTY_ATTRIBUTES = 'attributes';
export const PROPERTY_ATTRIBUTES_SELECTED = 'selectedAttributes';
export const PROPERTY_ATTRIBUTE_VALUES = 'attributeValues';
export const PROPERTY_PROPERTIES = 'properties';
export const PROPERTY_QUOTA = 'quota';
export const PROPERTY_QUOTA_COLLECTED = 'quotas';
export const PROPERTY_QUOTA_ASSIGNMENT_STRATEGY = 'quotaAssignmentStrategy';
export const PROPERTY_QUOTA_LIMIT_TYPE = 'quotaLimitType';
export const PROPERTY_LABEL = 'label';
export const PROPERTY_PROMPT = 'prompt';
export const PROPERTY_PROMPT_HTML = 'htmlPrompt';
export const PROPERTY_PROMPT_ORIGIN = 'originPrompt';
export const PROPERTY_ID = 'id';
export const PROPERTY_REF_ID = 'refId';
export const PROPERTY_GROUP_REF_ID = 'groupRefId';
export const PROPERTY_TRANSLATED_REF_ID = 'translatedRefId';
export const PROPERTY_TYPE = 'type';
export const PROPERTY_STYLE = 'style';
export const PROPERTY_ORDER = 'order';
export const PROPERTY_ORD = 'ord';
export const PROPERTY_SORT = 'sort';
export const PROPERTY_NEXT_Q = 'next_q';
export const PROPERTY_PRISTINE_VALUES = 'pristineValues';
export const PROPERTY_IS_SCREENING = 'isScreening';
export const PROPERTY_IS_SCREENER_ACTIVE = 'isScreenerActive';
export const PROPERTY_IS_FAVORITE = 'isFavorite';
export const PROPERTY_IS_CARRIED_FORWARD = 'isCarriedForward';
export const PROPERTY_IS_GOOGLE_TRANSLATED = 'isGoogleTranslated';
export const PROPERTY_HAS_PIPING = 'hasPiping';
export const PROPERTY_HAS_QUOTAS = 'hasQuotas';
export const PROPERTY_HAS_IMAGE = 'hasImage';
export const PROPERTY_TICKS = 'ticks';
export const PROPERTY_ALIAS = 'alias';
